<template>
    <v-dialog v-model="historyDialog" width="1600" scrollable>
        <template v-slot:activator="{ on, attrs }">
            <span style="justify-content: space-around; display: flex; margin-top: -3px;">
                <v-tooltip content-class="pa-0" left max-width="70%">
                    <template v-slot:activator="tooltip">
                        <v-btn
                            icon
                            small
                            v-on="tooltip.on"
                        >
                        <v-icon
                            color="grey"
                            small
                            :disabled="historyPreview.length <= 0 || !dependencyId"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-information
                        </v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-simple-table
                            class="text-size"
                            v-if="dependencyId && historyPreview.length > 0"
                            fixed-header
                            height="100%"
                            style="width: 100%; max-width: 100%;"
                        >
                            <thead>
                                <tr>
                                    <th class="text-size" scope="col">
                                        {{ $t("Modified by") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("Date") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("Name") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("From") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("To") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(entry, index) in historyPreview">
                                    <tr
                                        :key="'previewEntry-' + index"
                                    >
                                        <td class="text-size">{{ entry.updated_by }}</td>
                                        <td class="text-size">{{ entry.updated_at }}</td>
                                        <td class="text-size">{{ parseAttribute(entry.attribute) }}</td>
                                        <td class="text-size">{{ entry.from }}</td>
                                        <td class="text-size">{{ entry.to }}</td>    
                                    </tr>
                                </template>
                            </tbody>
                        </v-simple-table>
                        <span v-else class="d-block pa-3 text-size">
                            {{ $t("No data available") }}
                        </span>
                    </v-card>
                </v-tooltip>
            </span>
        </template>
        <v-card height="720" width="100%">
            <v-card-title>
                <v-row no-gutters>
                    <v-col cols="auto">
                        {{ $t("History") }}
                    </v-col>
                    <v-spacer />

                    <v-col cols="auto">
                        <v-btn
                            class="text-size"
                            text
                            color="primary"
                            @click="historyDialog = false"
                        >
                            {{ $t("Close") }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text @scroll="onScroll">
                <v-row>
                    <v-simple-table
                        fixed-header
                        height="100%"
                        style="width: 100%"
                    >
                        <thead>
                            <tr>
                                <th class="text-size" scope="col">
                                    {{ $t("Modified by") }}
                                </th>
                                <th class="text-size" scope="col">
                                    {{ $t("Date") }}
                                </th>
                                <th class="text-size" scope="col">
                                    {{ $t("Name") }}
                                </th>
                                <th class="text-size" scope="col">
                                    {{ $t("From") }}
                                </th>
                                <th class="text-size" scope="col">
                                    {{ $t("To") }}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="history.length > 0">
                            <template v-for="(entry, index) in history">
                                <tr
                                    :key="'entry-' + index"
                                >
                                    <td class="text-size">{{ entry.updated_by }}</td>
                                    <td class="text-size">{{ entry.updated_at }}</td>
                                    <td class="text-size">{{ parseAttribute(entry.attribute) }}</td>
                                    <td class="text-size">{{ entry.from }}</td>
                                    <td class="text-size">{{ entry.to }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </v-simple-table>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import {startCase} from 'lodash';

export default {
    name: "History",
    props: {
        dependencyId: {
            type: Number,
            default: undefined
        },
        historyPreview: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            historyDialog: false,
            history: [],
            showAmount: 100
        };
    },

    watch: {
        historyDialog(newValue) {
            if (newValue && !this.history.length) {
                this.fetchData();
            }
        }
    },

    methods: {
        fetchData() {
            return axios.get('cedexSettings/loadCedexDependenciesHistory', {
                params: {
                    dependencyId:  this.dependencyId
                }
            }).then(response => {
                if (
                    response.data.data
                    && response.data.data.length === 0
                ) {
                    this.history = [];
                } else {
                    this.history = response.data.data;
                    if (!this.history) {
                        this.history = [];
                    }
                }
            });
        },

        onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
            if (scrollTop + clientHeight + 150 >= scrollHeight) {
                this.showAmount += 100;
            }
        },

        parseAttribute(attribute) {
            return startCase(attribute);
        }
    }
};
</script>

<style scoped>
.text-size {
    font-size: 12px !important;

    max-width: 20vw;
    word-wrap: break-word;
}
.compact-form {
    transform: scale(0.75) translateY(-6px);
    transform-origin: left;
}

.selectedSpareParts >>> tr:not(:first-child) > td {
    border-top: 5px solid white;
}

.selectedSpareParts >>> tr.work-order:not(:first-child) > td {
    border-top: 0px;
}

.historyList {
    list-style-type: none;
}

.ui-terminal {
    /* margin-top: 5px; */
    height: 22em;

    border: 1px;
    overflow-y: scroll;
    border-style: solid;
    max-width: 40em;
    background-color: black;
    white-space: pre-wrap;
}
</style>
